import { merge } from 'lodash';

export default {
  updateSettings(state, data) {
    state.settings.company.uuid = data.companyUuid;
    state.settings.env = data.env;
    state.settings.language = data.language;
    merge(state.settings.user, data.user);
  },
  setTranslations(state, translations) {
    state.translations = Object.freeze(translations);
  },
};
